import { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { Button } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { useMetrics } from "@/src/hooks/useMetrics";
import { useStake } from "@/src/hooks/useStake";
import { toast } from "react-hot-toast";
import { activeChain } from "@/src/configs/chainConfig";
import { fmt } from "@/src/lib/utils";

export const RedeemRewards = () => {
  const { chain } = useAccount();
  const {  onMintReward, onMintRewardPendingRewards } = useStake();
  const { isConnected } = useAccount();
  const { frbBalance, rewardPoints, rewardRequirement, rewardReborn, pendingRewards } = useBalances();
  const { nftSupply } = useMetrics();
  const [, setValid] = useState(false);

  const validate = () => {
    if(rewardPoints < rewardRequirement){
      return true;
    }
    if(frbBalance < rewardReborn){
      return true;
    }
      return false;
  };
  useEffect(() => {
    const isValid = validate();
    setValid(isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frbBalance, rewardPoints, rewardReborn, rewardReborn, nftSupply]);


  const handleSubmit = async (event) => {
    if (!isConnected) return;
    event.preventDefault();
      toast.promise(onMintReward(), {
        loading: "Transaction is in progress",
        success: "Minted Flare Reborn NFT",
        error: (data) => data,
      });
  };
  const mintPending = async (event) => {
    if (!isConnected) return;
    event.preventDefault();
      toast.promise(onMintRewardPendingRewards(), {
        loading: "Transaction is in progress",
        success: "Minted Flare Reborn NFT",
        error: (data) => data,
      });
  };
  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });

  }, [chain, isConnected]);
  return (
    <div className="border border-border max-w-xl mx-auto w-full rounded-2xl bg-card/50 backdrop-blur-sm p-4 sm:p-6 space-y-6">
      <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider text-center">
        Reborn NFT
      </h2>

      <div className="flex justify-center">
        <div className="rounded-2xl overflow-hidden border border-border bg-secondary/30 p-2 shadow-lg mx-auto w-fit">
          <img src={process.env.PUBLIC_URL + 'CRF_KEY.gif'} className="w-full max-w-[280px] h-auto rounded-xl" alt="Reborn NFT" />
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="space-y-0 text-sm mb-6">
          <div className="flex items-center justify-between py-2.5 border-b border-border/50">
            <span className="text-sm text-muted-foreground">Supply</span>
            <span className="text-foreground font-semibold font-mono">{fmt(nftSupply, 0)}<span className="text-muted-foreground font-normal">/3333</span></span>
          </div>
          <div className="flex items-center justify-between py-2.5 border-b border-border/50">
            <span className="text-sm text-muted-foreground">Harvest Points</span>
            <span className="text-foreground font-semibold font-mono">{fmt(rewardPoints)}<span className="text-muted-foreground font-normal">/{fmt(rewardRequirement)}</span></span>
          </div>
          <div className="flex items-center justify-between py-2.5 last:border-0">
            <span className="text-sm text-muted-foreground">FRB Required</span>
            <span className="text-foreground font-semibold font-mono">{fmt(frbBalance)}<span className="text-muted-foreground font-normal">/{fmt(rewardReborn)}</span></span>
          </div>
        </div>

        <div className="space-y-3">
          <Button type="submit" disabled={!isCorrectChain || parseInt(rewardPoints) < parseInt(rewardRequirement) || rewardRequirement===0 || parseInt(frbBalance) < parseInt(rewardReborn)} >Mint Flare Reborn NFT</Button>
          <Button type="button" onClick={mintPending} disabled={!isCorrectChain || parseInt(rewardPoints) < parseInt(rewardRequirement) || rewardRequirement===0 || parseInt(pendingRewards) < parseInt(rewardReborn)} className="bg-secondary hover:bg-secondary/80 text-foreground">Mint NFT with pending rewards</Button>
        </div>
      </form>
    </div>
  );
};
